document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".flipbox").forEach(function(box) {
    let toggled = false; // each box has its own toggle state

    box.addEventListener("click", function() {
      const front = box.querySelector(".frontflip");
      const back = box.querySelector(".backflip");

      if (!toggled) {
        front.style.opacity = "0"; // hide front
        back.style.opacity = "1"; // show back
      } else {
        front.style.opacity = "1"; // show front
        back.style.opacity = "0"; // hide back
      }

      toggled = !toggled; // flip state for this box only
    });
  });
});
